import { render, staticRenderFns } from "./HeaderBlock.vue?vue&type=template&id=956e80d6&scoped=true"
import script from "./HeaderBlock.vue?vue&type=script&lang=js"
export * from "./HeaderBlock.vue?vue&type=script&lang=js"
import style0 from "./HeaderBlock.vue?vue&type=style&index=0&id=956e80d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956e80d6",
  null
  
)

export default component.exports